import React from "react"
import { graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import styled from "styled-components"

import Layout from "../components/layout-v2"
import Seo from "../components/seo"
import DataMiners from "../components/home-components/data-miners"
import UniqueApproach from "../components/home-components/unique-approach"
import DigitalMarketing from "../components/home-components/digital-marketing"
import ExperienceCreators from "../components/home-components/experience-creators"
import ServicesLoop from "../components/ServicesLoop/ServicesLoop"
import Testimonial from "../components/Testimonial/Testimonial"

const ServicesPage = ({ data: { services, pageContent, bannerImg } }) => {
  const ourServices = services.edges
  const content = pageContent.edges

  return (
    <Layout>
      {content.map(page => {
        const servicesPageContent = page.node.ServicesPageContent
        return (
          <>
            <Seo
              title={page.node.SEOmeta.metaTitle}
              description={page.node.SEOmeta.metaDescription}
              keywords={page.node.SEOmeta.metaKeywords}
              ogTitle={page.node.SEOmeta.ogTitle}
              ogDescription={page.node.SEOmeta.ogDescription}
              ogImage={
                page.node.SEOmeta.ogImage.localFile.childImageSharp.fluid
              }
              twitterTitle={page.node.SEOmeta.twitterTitle}
              twitterDescription={page.node.SEOmeta.twitterDescription}
              twitterImage={
                page.node.SEOmeta.twitterImage.localFile.childImageSharp.fluid
              }
            />
            <div style={{ padding: "0 20px" }}>
              <TitleSection>
                <div class="header-border">
                  <h1>Approach</h1>
                  <p>
                    Full service is old school. When data, design and delivery
                    combine, we're full flywheel.
                  </p>
                </div>
                <div class="hero-banner banner-2">
                  <div
                    data-sal="fade"
                    data-sal-duration="1000"
                    data-sal-easing="ease"
                  >
                    <GatsbyImage
                      className={"hero-bg hero-bg-2"}
                      image={bannerImg.childImageSharp.gatsbyImageData}
                      alt={"Hahn.Agency Services Banner Background"}
                    />
                  </div>
                </div>
              </TitleSection>
              <UniqueApproach />
              <DataMiners />
              <ExperienceCreators />
              <DigitalMarketing />
              <CopySection>
                <div
                  dangerouslySetInnerHTML={{
                    __html: servicesPageContent.firstParagraph,
                  }}
                />
              </CopySection>
              <ServicesLoop services={ourServices} />
              <Testimonial
                testimonialContent={servicesPageContent.servicesPageTestimonial}
              />
            </div>
          </>
        )
      })}
    </Layout>
  )
}

const TitleSection = styled.header`
  position: relative;
  max-width: 1320px;
  width: 100%;
  padding: 40px;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 60px;
  background-color: #000;
  .header-border {
    border: 10px solid #fff;
    padding: 120px;
    position: relative;
    z-index: 10;
  }
  .hero-banner {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    div {
      height: 100%;
    }
    .gatsby-image-wrapper {
      height: 100%;
    }
    img {
      width: 100%;
      height: 100%;
    }
    .hero-bg {
      position: absolute;
      width: 100%;
      height: 100%;
      top: 0;
      left: 0;
      opacity: 0;
      visibility: hidden;
    }
    &.banner-1 {
      .hero-bg-1 {
        opacity: 1;
        visibility: visible;
      }
    }
    &.banner-2 {
      .hero-bg-2 {
        opacity: 1;
        visibility: visible;
      }
    }
  }
  h1 {
    font-size: 100px;
    color: #fff;
    margin-top: 0;
    margin-bottom: 20px;
    position: relative;
    z-index: 2;
    text-align: center;
    &:hover {
      cursor: default;
    }
  }
  p {
    font-family: "Work Sans";
    color: #fff;
    font-size: 44px;
    font-weight: 400;
    line-height: 1.3;
    margin-bottom: 0;
    position: relative;
    z-index: 2;
    text-align: center;
    &:hover {
      cursor: default;
    }
  }
  @media (max-width: 1000px) {
    max-width: 700px;
    padding: 45px;
    .header-border {
      padding: 80px;
    }
    h1 {
      font-size: 60px;
    }
    p {
      font-size: 24px;
    }
  }
  @media (max-width: 767px) {
    max-width: 500px;
    padding: 20px;
    margin-bottom: 20px;
    h1 {
      font-size: 44px;
    }
    p {
      font-size: 18px;
      line-height: 1.4;
    }
    .header-border {
      padding: 40px 20px;
    }
  }
`

const CopySection = styled.section`
  max-width: 840px;
  width: 100%;
  margin: 100px auto;
  margin-bottom: 40px;
  padding: 0;
  h2 {
    font-family: "Nobel", sans-serif;
    font-size: 50px;
    line-height: 1.1;
    font-weight: 700;
    color: #2b2520;
    margin-top: 0;
    margin-bottom: 10px;
    text-align: center;
  }
  p {
    font-family: "Work Sans";
    font-size: 24px;
    line-height: 34px;
    font-weight: 400;
    color: #777c7c;
    margin-top: 0;
    margin-bottom: 0;
    text-align: center;
  }
  @media (max-width: 1000px) {
    max-width: 700px;
    padding: 0 55px;
    h2 {
      font-size: 40px;
    }
    p {
      font-size: 20px;
    }
  }
  @media (max-width: 767px) {
    max-width: 500px;
    margin: 20px auto;
    padding: 0px;
    h2 {
      font-size: 24px;
      line-height: 1.3;
    }
    p {
      font-size: 16px;
      line-height: 1.4;
    }
  }
`

export default ServicesPage

export const pageQuery = graphql`
  query {
    services: allWpOurService {
      edges {
        node {
          title
          slug
          ServiceDescription {
            serviceDescriptionContent
          }
        }
      }
    }
    bannerImg: file(relativePath: { eq: "header02.jpg" }) {
      childImageSharp {
        gatsbyImageData(
          width: 2000
          placeholder: BLURRED
          formats: [AUTO, WEBP, AVIF]
        )
      }
    }
    pageContent: allWpCustomPage(filter: { databaseId: { eq: 1236 } }) {
      edges {
        node {
          SEOmeta {
            metaTitle
            metaDescription
            metaKeywords
            ogTitle
            ogDescription
            ogImage {
              localFile {
                childImageSharp {
                  fluid(maxWidth: 1320, quality: 100) {
                    ...GatsbyImageSharpFluid_withWebp
                  }
                }
              }
            }
            twitterTitle
            twitterDescription
            twitterImage {
              localFile {
                childImageSharp {
                  fluid(maxWidth: 1320, quality: 100) {
                    ...GatsbyImageSharpFluid_withWebp
                  }
                }
              }
            }
          }
          ServicesPageContent {
            firstParagraph
            servicesPageTestimonial {
              spTestimonialAuthor
              spTestimonialAuthorInfo
              spTestimonialContent
            }
          }
        }
      }
    }
  }
`
